import axios from 'axios';
import { Mail } from './types';

export const postMail = async (params: Mail) => {
  return axios.post(`/v1/email`, params);
};
